import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import db from "../../../../../db"
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import FormDialog from "../FormDialog/FormDialog"
import { toast } from 'react-toastify';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import SearchInput from "../../../../../components/SearchInput"


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const DataTable = props => {
  const { className, ...rest } = props;
  const [data, setData] = useState([])
  const [data2, setData2] = useState([])
  const [filteredData2, setFilteredData2] = useState([])
  const [opChange, setOpChange] = useState(false);
  const [opCopy, setOpCopy] = useState(false);


  const [brand, setBrand] = useState()
  const [model, setModel] = useState()
  const [name, setName] = useState()
  const [modelCode, setModelCode] = useState()
  const [country, setCountry] = useState()
  const [sizeStandart, setSizeStandart] = useState()
  const [sizeStandartData, setSizeStandartData] = useState([])
  let [id, setId] = useState()

  const fields = {
    brand: {
      value: brand,
      func: setBrand
    },
    model: {
      value: model,
      func: setModel
    },
    name: {
      value: name,
      func: setName
    },
    modelCode: {
      value: modelCode,
      func: setModelCode
    },
    country: {

      value: country,
      func: setCountry
    },
    sizeStandart: {
      value: sizeStandart,
      func: setSizeStandart,
      data: sizeStandartData
    },
  }

  useEffect(() => {
    db.ref('Product').orderByChild("/modelCode").on('value', snap => {
      if (snap.val()) {
        const dd = snap.val()
        const newd = []
        Object.keys(dd).map(el => {
          const elem = dd[el]
          elem.keyId = el
          newd.push(elem)
        })
        console.log(newd);
        setData(snap.val())
        setData2(newd)
        setFilteredData2(newd)

      } else {
        setData2([])
        setData([])
      }
    })
  }, [])

  const handleDelete = (keyId) => {
    db.ref('Product/' + keyId).remove().then(() => {
      toast.success('Հեռացված է')
    })
  }

  const handleEdit = (keyId) => {
    setId(keyId)
    setBrand(data[keyId].brand)
    setModel(data[keyId].model)
    setName(data[keyId].name)
    setModelCode(data[keyId].modelCode)
    setCountry(data[keyId].country)
    setSizeStandart(data[keyId].sizeStandart)
    setOpChange(true)

    db.ref('InfoCenter/Sizes').once('value').then(snap => {
      if (snap.val()) {
        setSizeStandartData(snap.val())
      }
    })
  }

  const handleCopy = (keyId) => {
    setId(keyId)
    setBrand(data[keyId].brand)
    setModel(data[keyId].model)
    setName(data[keyId].name)
    setModelCode(data[keyId].modelCode)
    setCountry(data[keyId].country)
    setSizeStandart(data[keyId].sizeStandart)
    setOpCopy(true)

    db.ref('InfoCenter/Sizes').once('value').then(snap => {
      if (snap.val()) {
        setSizeStandartData(snap.val())
      }
    })
  }

  const handleAdd = () => {
    if (brand && model && name && modelCode && country && sizeStandart) {
      db.ref().child('Product').push({
        brand: brand,
        model: model,
        name: name,
        modelCode: modelCode,
        country: country,
        sizeStandart: sizeStandart
      }).then(() => {
        setBrand()
        setModel()
        setName()
        setModelCode()
        setCountry()
        setSizeStandart()
        toast.success('Ավելացված է');
        setOpCopy(false)
      })
    } else {
      toast.error('Լրացրեք բոլոր դաշտերը')
    }
  }

  const handleSort = (i) => {
    const a = filteredData2.sort((a, b) => (a[i] > b[i]) ? 1 : ((b[i] > a[i]) ? -1 : 0))
    setData2([...a]);
  }

  const handleSaveEdit = () => {
    if (!brand || !model || !name || !modelCode || !country || !sizeStandart) {
      toast.error('Լրացրեք բոլոր դաշտերը')
      return
    }
    if (id) {
      db.ref('Product/' + id).set({
        brand: brand,
        model: model,
        name: name,
        modelCode: modelCode,
        country: country,
        sizeStandart: sizeStandart
      }).then(() => {
        toast.success('Փոփոխված է')
        setOpChange(false)
        setBrand()
        setModel()
        setName()
        setModelCode()
        setCountry()
        setSizeStandart()
      })
    }
    setId()
  }

  const handleSearch = (e) => {
    const filtered = data2.filter((el) => {
      return el.modelCode.toLowerCase().includes(e.toLowerCase()) ||
        el.brand.toLowerCase().includes(e.toLowerCase()) ||
        el.model.toLowerCase().includes(e.toLowerCase()) ||
        el.name.toLowerCase().includes(e.toLowerCase()) ||
        el.country.toLowerCase().includes(e.toLowerCase()) ||
        el.sizeStandart.toLowerCase().includes(e.toLowerCase())
    })
    setFilteredData2(filtered);
  }

  const classes = useStyles();

  return (
    <div>
      <SearchInput onChange={(e) => handleSearch(e.target.value)} />
      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell onClick={() => handleSort("modelCode")} style={{ "cursor": "pointer" }}>Մոդելի կոդ </TableCell>
                      <TableCell onClick={() => handleSort("brand")} style={{ "cursor": "pointer" }}>Բրենդ</TableCell>
                      <TableCell onClick={() => handleSort("model")} style={{ "cursor": "pointer" }}>Մոդել</TableCell>
                      <TableCell onClick={() => handleSort("name")} style={{ "cursor": "pointer" }}>Կարճ անուն</TableCell>
                      <TableCell onClick={() => handleSort("country")} style={{ "cursor": "pointer" }}>Երկիր</TableCell>
                      <TableCell onClick={() => handleSort("sizeStandart")} style={{ "cursor": "pointer" }}>Չափսի ստանդարտ</TableCell>
                      <TableCell>Գործողություն</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredData2.map(i => (
                      < TableRow
                        className={classes.tableRow}
                        hover
                        key={i.keyId}
                      >
                        <TableCell>
                          {i.modelCode}
                        </TableCell>
                        <TableCell>
                          {i.brand}
                        </TableCell>
                        <TableCell>
                          {i.model}
                        </TableCell>
                        <TableCell>
                          {i.name}
                        </TableCell>
                        <TableCell>
                          {i.country}
                        </TableCell>
                        <TableCell>
                          {i.sizeStandart}
                        </TableCell>
                        <TableCell>
                          <IconButton color="primary" onClick={() => handleEdit(i.keyId)} style={{ "padding": "0" }}>
                            <EditIcon />
                          </IconButton>
                          <IconButton color="primary" size="small" onClick={() => handleDelete(i.keyId)} >
                            <DeleteForeverIcon />
                          </IconButton>
                          <IconButton color="primary" onClick={() => handleCopy(i.keyId)} style={{ "padding": "0" }} >
                            <FileCopyIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </PerfectScrollbar>
        </CardContent>
        <FormDialog op={opChange} setOp={setOpChange} title="Փոփոխել արտադրանքը" func={handleSaveEdit} fields={fields} />
        <FormDialog op={opCopy} setOp={setOpCopy} title="Կրկնապատկել արտադրանքը" func={handleAdd} fields={fields} />
      </Card >
    </div>
  );
};

DataTable.propTypes = {
  className: PropTypes.string
};

export default DataTable;
